import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from '../rest_services/dashboard.service';
import { VisitService } from '../rest_services/visit.service';
import { programme_day } from './data_visits';
import {formatDate} from '@angular/common';
import { Router } from '@angular/router';
import { getUniqueId } from '../rest_services/utilFunctions/functions_utiles';
import { MsSectorService } from '../rest_services/ms-sector.service';
import { SettingsService } from '../rest_services/settings.service';
import { formatInTimeZone } from 'date-fns-tz';
declare var $: any;
declare var Snap:any;
declare var NotificationFx:any;

@Component({
  selector: 'app-dash-commercial',
  templateUrl: './dash-commercial.component.html',
  styleUrls: ['./dash-commercial.component.css']
})
export class DashCommercialComponent implements OnInit {
  defaultLinkTitle = "showLess";
  allshowing: boolean=false;
  loading_plan:boolean=true;
  showmore() {
    this.allshowing=true;
    this.today = this.allVisitsday;
  }
  showless(){
    this.today =this.today.slice(0, 4);
    this.allshowing=false;
  }

  visitInProgress:boolean=false;
  programme:any[]=programme_day;
  finishVisitForm:FormGroup;
  terminatedVisitForm:FormGroup;
  cancelVisitForm:FormGroup;
  newActionForm:FormGroup;
  comp:any;
  resumLength:any;

  token!: string;
  uuid!: string;
  reportedVisits:any[]=[];
  canceledVisits:any[]=[];
  affectedVisits:number=0;
  affectedplanifiedVisits:any[]=[];
  affectedVisitsLoader = true;
  canceledVisitsLoader = true;
  reportedVisitsLoader = true;

  constructor(private fb:FormBuilder,private dashboardServiceservice:DashboardService,private msSector : MsSectorService,
    private visitService:VisitService,private router:Router, private settingsService:SettingsService) {
    this.getVisitsToReplyNotif();
      this.getAffected(1);
      this.getAffected(2);
      this.getAffected(4);
      this.getAffected(5);
    this.Terminated();
    this.terminatedVisitForm = this.fb.group({
      'contact_fullname': ['', Validators.required],
      'contact_function' : [''],
      'contact_phone' : ['', [Validators.pattern("^((\\+91-?)|0)?[0-9+]{10,13}$")]],
      'contact_email' : ['', [Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
    });
    this.finishVisitForm = this.fb.group({
      'type_sell': [''],
      'designation' : ['', Validators.required],
      'price' : ['', Validators.required],
      'product_unit' : ['', Validators.required],
    });
    this.cancelVisitForm = this.fb.group({
      'motif' : ['', [Validators.required,Validators.maxLength(2000)]],
      'reportDate' :['', this.validateDate]
    });
    this.newActionForm = this.fb.group({
      'action': ['', Validators.required],
      'comment' : [''],
      'statusAction' : ['', Validators.required]
    });
   }
   validateDate(control: any) {
    const selectedDate = new Date(control.value);
    const currentDate = new Date();
    selectedDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
  
    if (selectedDate < currentDate) {
      return { 'invalidDate': true };
    }

    return null;
  }
  //CALENDAR VARS
  list:any[]=[
    {
      title: "init title",
      start: '2022-05-05 16:00',
      uuid:"init uuid",
      status: "init status",
      commercial:"init commercial",
      customer:"init customer",
      inProgress:true
    }
  ]
  detail_event:any={};
  eventsAll:any[]=[];
  connectedCommercial:any="";
  logged:any=null;
  newAction:any=null;
  newComment:any=null;
  imgWrap:any = "";
  imgArray:any[] = [];
  picturesVisit:any[]=[];
  picturesVisitUpdate:any[]=[];
  addPic(event:any,modal:any){
    // if(modal =="terminate"){
      this.imgWrap = $('.upload__inputfile').closest('.upload__box').find('.upload__img-wrap');
    // }else {
    //   this.imgWrap = $('.upload__inputfile_update').closest('.upload__box').find('.upload__img-wrap');
    // }
    
    var maxLength = $(this).attr('data-max_length');
    
    var files:any = event.target.files;
    var filesArr:any = Array.prototype.slice.call(files);
    var iterator:any = 0;
    var glob=this;
    filesArr.forEach(function (f:any, index:any) {
      
      if (!f.type.match('image.*')) {
        return;
      }

      if (glob.imgArray.length > maxLength) {
        return false
      } else {
        var len = 0;
        for (var i = 0; i < glob.imgArray.length; i++) {
          if (glob.imgArray[i] !== undefined) {
            len++;
          }
        }
        if (len > maxLength) {
          return false;
        } else {
          glob.imgArray.push(f);

          var reader = new FileReader();
          reader.onload = function (e:any) {
            
            // if(modal =="terminate"){
              var html = "<div class='upload__img-box'><div style='background-image: url(" + e.target.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + f.name + "' class='img-bg'><div class='upload__img-close'></div></div></div>";
              glob.imgWrap.append(html);
              glob.picturesVisit.push(e.target.result);
              
            // }else {
            //   var html = "<div class='upload__img-box'><div style='background-image: url(" + e.target.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + f.name + "' class='img-bg'><div class='upload__img-close' id='deletePicture'></div></div></div>";
            //   glob.imgWrap.append(html);
            //   glob.picturesVisitUpdate.push(e.target.result);
            //   glob.picturesVisit.push(e.target.result);
            // }
            iterator++;
          }
          reader.readAsDataURL(f);
        }
      }
    });
  }
  visitDeadlineValue :any;
  msToken : any = '';
  ngOnInit(): void {
    this.getConfig();
    this.msToken = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");
    var glob =this;
    $('body').on('click', ".upload__img-close", function (e:any) {
      var file = $(this).parent().data("file");
      for (var i = 0; i < glob.imgArray.length; i++) {
        if (glob.imgArray[i].name === file) {
          glob.imgArray.splice(i, 1);
          glob.picturesVisit.splice(i, 1);
          break;
        }
      }
      $(this).parent().parent().remove();
    });
    var dateNow = new Date();
    var firstDay = new Date(dateNow.getFullYear(), dateNow.getMonth(), 2);
    var lastDay = new Date(dateNow.getFullYear(), dateNow.getMonth() + 1, 0);
    var startDateInput = document.getElementById('startDate') as any;
    var endDateInput = document.getElementById('endDate') as any;
    startDateInput.valueAsDate = firstDay;
    endDateInput.valueAsDate = lastDay;
    if(localStorage.getItem("role")=="adm" || sessionStorage.getItem("role")=="adm"){
      this.router.navigate(['../dashboard']);
    }  else if (localStorage.getItem("role")=="asst" || sessionStorage.getItem("role")=="asst"){
      this.router.navigate(['../dash']);
    } else {
      this.router.navigate(['../mydash']);
    }
    setTimeout(()=>{
      if(localStorage.getItem("fullname")!=undefined) {
        this.connectedCommercial =localStorage.getItem("fullname");
        this.logged=localStorage.getItem("logged");
      }else if(sessionStorage.getItem("fullname")!=undefined){
        this.connectedCommercial =sessionStorage.getItem("fullname");
        this.logged=sessionStorage.getItem("logged");
      }
    },1000);

    //commercial uuid
    this.token = this.dashboardServiceservice.token;
    let decodedJWT = JSON.parse(window.atob(this.token.split('.')[1]));
    this.uuid = decodedJWT.userId;
    
    //CALENDAR FUNCTIONS
    // this.getCalendarVisits();
    this.TodayPlanning();
    //SHOW NOTIFICATION TO COMMERCIAL TO CREATE NEW VISITS
    var svgshape = document.getElementById( 'notification-corner-expand-shape' )as HTMLElement,
      s = Snap( svgshape?.querySelector( 'svg' ) ),
      path = s.select( 'path' ),
      pathConfig = {
          from : path?.attr( 'd' ),
          to : svgshape?.getAttribute( 'data-path-to' )
      }
      NotificationFx.prototype.options = {
        wrapper : document.body,
        message : 'yo!',
        layout : 'growl',
        effect : 'slide',
        type : 'error',
        ttl : 180000, //TIMEOUT CLOSE NOTIFICATIONS - BY ROU
        // callbacks
        onClose : function() { return false; },
        onOpen : function() { return false; }
      }
    
    // $('.notification-shape.shape-box').addClass('ns-shape-show');
    //   setTimeout( function() {
    //       // create the notification
    //       var notification = new NotificationFx({
    //           wrapper : svgshape,
    //           message : '<p><i class="icon flaticon-idea-bulb"></i> I\'m appaering in a morphed shape thanks to <a href="#">Snap.svg</a></p>',
    //           layout : 'other',
    //           effect : 'cornerexpand',
    //           type : 'notice', // notice, warning or error
    //           onClose : function() {
    //               setTimeout(function() {
    //                   $('.notification-shape.shape-box').addClass('ns-shape-show');
    //               }, 10000 );
    //           }
    //       });
    //       // show the notification
    //       notification.show();
    //   }, 1200 );


          // simulate loading (for demo purposes only)
          




    this.finishVisitForm.controls.type_sell.setValue("product");
    if(localStorage.getItem("role")!=undefined) {
      this.comp=localStorage.getItem("comp");
    }else if(sessionStorage.getItem("role")!=undefined){
      this.comp=sessionStorage.getItem("comp");
    }
    
    var glob = this;
    $(document).on("click",".fc-day-grid-event, .commercialName, .customerName", function () {
      var clickedBtnID = $(this).find("span").attr('this-date-uuid'); // or var clickedBtnID = this.id
      var selectedEvent = glob.list.find(d => d.uuid== clickedBtnID);
      if(selectedEvent != undefined){
        glob.detail_event = selectedEvent;
        var detail = "";
        $("#eventDetails").append(detail);
        const myNode = document.getElementById("eventDetails") as any;
        myNode.innerHTML = '';
        const myNodelist = document.getElementById("eventlist") as any;
        myNodelist.innerHTML = '';
        myNodelist.innerHTML = '';
        detail +='<div id="blocEvent" class="col-lg-12 col-md-12 col-xs-12 col-sm-12 pt-2 pb-2 mb-3 mr-0 '+selectedEvent.status+
            '_container" style="border-radius: 15px;box-shadow: 0px 6px 5px #818181;">'+
            '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mb-4 text-center">'
        if(selectedEvent.commercial_avatar!=null){
          detail += '<img class="images_pop_detail_calendar " src="data:image/png;base64,'+selectedEvent.commercial_avatar+'"'+ 
          '>';
        }else {
          detail += '<img class="images_pop_detail_calendar" src="assets/img/unknown_user.jpg"'+
          '>';
        }
        if(selectedEvent.customer_logo!=null){
          detail += '<img class="images_pop_detail_calendar" src="data:image/png;base64,'+selectedEvent.customer_logo+'"'+
          '>';
        }else {
          detail += '<img class="images_pop_detail_calendar" src="assets/img/logo.jpg"'+
          '>';
        }
        detail += '</div>'+
              '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/customer.gif" style="width: 25px;margin-bottom: 6px;"><b> Visite de </b></span>'+
              '<p class=" pr-3"> '+selectedEvent.customer+'</p>'+
            '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
              '<b>Visite topic</b>'+
              '<p class=" pr-3"> '+selectedEvent.title+'</p>'+
            '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/commercial.gif" style="width: 25px;margin-bottom: 6px;"><b> Affectée à </b></span>'+
              '<p class=" pr-3"> '+selectedEvent.commercial+'</p>'+
            '</div>'+
            '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/calendar.gif" style="width: 25px;"><b> Date de visite</b></span>'+
              '<p class="pr-3"> '+selectedEvent.start.substring(0,10)+'</p>'+
            '</div>';
            if(selectedEvent.started_at!=null){
              var startedAt =formatDate(selectedEvent.started_at,'dd-MM-yyyy à HH:mm','en-US')
              detail += '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/inprogress.gif" style="width: 25px;"><b> Visite démarrée le</b></span>'+
              '<p class="pr-3"> '+startedAt+'</p>'+
            '</div>';
            }
            if(selectedEvent.finished_at!=null){
              var finishedAt =selectedEvent.finished_at;
              detail += '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/goal.gif" style="width: 25px;"><b> Visite terminée le</b></span>'+
              '<p class="pr-3"> '+finishedAt+'</p>'+
            '</div>';
            }
            var statusVIsit = null;
            if(selectedEvent.status!=null){
              if(selectedEvent.status =="Terminated"){
                statusVIsit = "Visite Terminée";
              }else if(selectedEvent.status =="Planned"){
                statusVIsit = "Visite Créée";
              }else if(selectedEvent.status =="inProgress"){
                statusVIsit = "Visite En cours";
              }else if(selectedEvent.status =="Reported"){
                statusVIsit = "Visite Reportée";
              }else {
                statusVIsit = "Visite En attente de validation";
              }
              if(selectedEvent.status =="Reported"){
                detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/status_rep_canc.gif" style="width: 25px;"><b> Statut</b></span>'+
                '<p class="pr-3"> '+statusVIsit+'</p>'+
                '</div>';
              }else {
                detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/status.gif" style="width: 25px;"><b> Statut</b></span>'+
                '<p class="pr-3"> '+statusVIsit+'</p>'+
                '</div>';
              }
            }
            if(selectedEvent.goal!=null && selectedEvent.goal!=""){
              detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/goal_visit.gif" style="width: 45px;"><b> Objectif de la visite</b></span>'+
              '<p class="pr-3"> '+selectedEvent.goal+'</p>'+
            '</div>';
            }
            detail += '</div>';
            if(selectedEvent.finished_at!=null){
              detail += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 text-center">'+
                '<a href="javascript:void(0)" class="text-primary generateRepport" report-uuid="'+selectedEvent.uuid+'">Générer le rapport (pdf)</a></div> '
            }
        setTimeout(()=>{
          $('#detail_event').modal('show');
          $("#eventDetails").append(detail);
          detail = "";
        },500);
      }
    });
    setTimeout(()=>{
      $(document).on("click",".fc-more-cell", function () {
        for(let event of glob.list){
          var ev = (document.querySelector("[this-date-uuid='"+event.uuid+"']")) as any;
          if(event.inProgress){
            if(ev!=undefined && ev!=null){
              var parenthyper = ev.parentElement;
              parenthyper.parentElement.classList.add("encours");
            }
          }
        }
      });
    },800);
    $(document).on("click",".fc-day-top", function () {
      var clickedColDate = $(this).attr('data-date'); // or var clickedBtnID = this.id      
      var selectedEvent = glob.list.filter(d => d.start.includes(clickedColDate));
      if(selectedEvent.length>0){
        this.noVisitCalendarDay=false;
        const myNode = document.getElementById("eventlist") as any;
        myNode.innerHTML = '';
        $('#eventsOfDay').modal('show');
        // setTimeout(()=>{
          this.eventsAll = selectedEvent;
          var list = "";          
          for(var ev of this.eventsAll){
            list +='<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 pt-2 pb-2 mb-3 mr-0 '+ev.status+
            '_container" style="border:3px solid #805dca;color:black;border-radius: 15px;box-shadow: 0px 6px 5px #818181;">'+
              '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mb-4 text-center">';
              if(ev.commercial_avatar!=null){
                list += '<img class="images_pop_detail_calendar_list " src="data:image/png;base64,'+ev.commercial_avatar+'"'+ 
                '>';
              }else {
                list += '<img class="images_pop_detail_calendar_list" src="assets/img/unknown_user.jpg"'+
                '>';
              }
              if(ev.customer_logo!=null){
                list += '<img class="images_pop_detail_calendar_list" src="data:image/png;base64,'+ev.customer_logo+'"'+
                '>';
              }else {
                list += '<img class="images_pop_detail_calendar_list" src="assets/img/logo.jpg"'+
                '>';
              }
              list += '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/customer.gif" style="width: 25px;margin-bottom: 6px;"><b> Visite de </b></span>'+
                '<p class=" pr-3"> '+ev.customer+'</p>'+
              '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6 " style="display: inline-grid;">'+
                '<b>Visite topic</b>'+
                '<p class=" pr-3"> '+ev.title+'</p>'+
              '</div><div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/commercial.gif" style="width: 25px;margin-bottom: 6px;"><b> Affectée à </b></span>'+
                '<p class="pr-3"> '+ev.commercial+'</p>'+
              '</div>'+
              '<div class="col-lg-6 col-md-6 col-xs-6 col-sm-6" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/calendar.gif" style="width: 25px;"><b> Date de visite</b></span>'+
                '<p class="pr-3"> '+ev.start.substring(0,10)+'</p>'+
              '</div>';
              if(ev.goal!=null && ev.goal!=""){
                list += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
                '<span><img src="assets/img/suivitim_img/gif_status_visit/goal_visit.gif" style="width: 35px;"><b> Objectif de la visite</b></span>'+
                '<p class="pr-3"> '+ev.goal+'</p>'+
              '</div>';
              }
              var statusVIsit = null;
              if(ev.status!=null){
              if(ev.status =="Terminated"){
                statusVIsit = "Visite Terminée";
              }else if(ev.status =="Planned"){
                statusVIsit = "Visite Créée";
              }else if(ev.status =="inProgress"){
                statusVIsit = "Visite En cours";
              }else if(ev.status =="Reported"){
                statusVIsit = "Visite Reportée";
              }else {
                statusVIsit = "Visite En attente de validation";
              }
              list += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12" style="display: inline-grid;">'+
              '<span><img src="assets/img/suivitim_img/gif_status_visit/status.gif" style="width: 25px;"><b> Statut</b></span>'+
              '<p class="pr-3"> '+statusVIsit+'</p>'+
            '</div>';
            }
              list += '</div>';
              if(ev.finished_at!=null && ev.finished_at!=""){
                list += '<div class="col-lg-12 col-md-12 col-xs-12 col-sm-12 mb-4 mt-2" style="display: inline-grid;top: -14px;text-align: center;">'+
                '<span><img src="assets/img/suivitim_img/pdf.gif" style="width: 30px;"><b> <a href="javascript:void(0)" class="text-primary '+
                'generateRepport" report-uuid="'+ev.uuid+'">Générer le rapport</a></b></span></div>';
              }
              
          }
          $("#eventlist").append(list);
        // },1000);
      }
    });
    $(document).on("click",".generateRepport", function () {
      var clickedFinishedVisit = $(this).attr('report-uuid');
      glob.Pdf(clickedFinishedVisit);
    });
    
    $(document).on("click",".fc-agendaDay-button", function () {
      if (window.matchMedia('screen and (max-width: 768px)').matches) {
        var testarray = (document).getElementsByClassName("fc-event-container") as any;
        for(var i = 0; i < testarray.length; i++){
          testarray.item(i).status += " display_content";
        }
          
      }
    })
    
  }

  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.visitDeadlineValue = resp.config.visitDeadline;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  selectedvisit: any;
  cause:any;
  company:any;
  getAffected(status:number){
    this.dashboardServiceservice.getAffected(status).subscribe(
      ( data: any ) => {     
        if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
          switch (status) { 
           case 1:
             this.affectedVisits = data.visits.length;
             break;
          case 2:
             this.affectedplanifiedVisits = data.visits;
          break;
           case 4:
             this.canceledVisits = data.visits;
             break;
           case 5:
             this.reportedVisits = data.visits;
             break;
           default:
             break;
          } 
          this.affectedVisits = this.affectedVisits+this.affectedplanifiedVisits.length;
        }

        switch (status) { 
          case 1:
            this.affectedVisitsLoader = false;
            break;
          case 4:
            this.canceledVisitsLoader = false;
            break;
          case 5:
            this.reportedVisitsLoader = false;
            break;
         
          default:
            break;
         }
        
      },
      (err:any) =>{
        console.log(err);
        switch (status) { 
          case 1:
            this.affectedVisitsLoader = false;
            break;
          case 4:
            this.canceledVisitsLoader = false;
            break;
          case 5:
            this.reportedVisitsLoader = false;
            break;
         
          default:
            break;
         }
      }
    )  
  }
  toconfirm(visit:any){
    this.getConfig();
    this.selectedvisit=null;
    this.selectedvisit = visit.visit;
    this.company = visit.customer_rs;
    this.perso=[];
    this.adaptedActions=[];
    this.Detail(this.selectedvisit);
    this.cancelVisitForm.reset();

  }
  Idcall(visite:any){
    this.person=[];
    this.cause = visite.report_visit;
    this.Retrieve(this.cause);
  }
  startLoading:boolean=false;
  startVisit(){
    const id = this.selectedvisit;
    let item1 = this.today.find((i:any) => i.visit === this.selectedvisit);
    var index = this.today.indexOf(item1);
   
    if(!this.exist_incompleted_visit){
      
      this.exist_incompleted_visit=true;
      var loading = (document.getElementById("startLoading"+index) as HTMLDivElement);
      loading.style.display = "inline-block";
      this.startLoading = true;

      // Check if start time is stored in localStorage
      const startTimeStr = localStorage.getItem(`startTime_${id}`);
      const startTime = startTimeStr ? new Date(startTimeStr) : new Date();

      this.dashboardServiceservice.startVisit(this.selectedvisit);
      this.dashboardServiceservice.startVisitSubject.subscribe(
      ( data: any ) => {
        if(data.code =="802ddb379ec8898a9c3fd49cdc5f924c"){
          if (index !== -1) {
            item1.visit_status="En cours";
            loading.style.display = "none";
            this.getCalendarVisits();
            this.selectedvisit={};
            this.perso=[];
            // Disable the "Start Visit" button for other visits
            this.today.forEach((visit: any, i: number) => {
              if (i !== index) {
                visit.disableStartButton = true;
              }
            });

            // Calculate deadline time
            const deadlineTime = new Date(startTime.getTime() + (this.visitDeadlineValue * 60 * 1000));
            
            // Set a flag to show the "Terminer la visite" button if the deadline has passed
            item1.showEndButton = new Date() > deadlineTime;
            setTimeout(() => {
              item1.showEndButton = true;
            }, this.visitDeadlineValue * 60 * 1000);

            // Store start time in localStorage
            localStorage.setItem(`startTime_${id}`, startTime.toISOString());
          }
        }
      })
    }
}


  cancelVisit(){
      var cancelVisitFormValues= this.cancelVisitForm.value;
      let item1 = this.today.find((i:any) => i.visit === this.selectedvisit);
      var index = this.today.indexOf(item1);
      // if(this.exist_incompleted_visit){
        var loading = (document.getElementById("startLoading"+index) as HTMLDivElement);
        loading.style.display = "inline-block";
        this.startLoading = true;
        const requestBody = {
          cause: cancelVisitFormValues.motif,
          reportDate: cancelVisitFormValues.reportDate
        };
        this.dashboardServiceservice.cancelVisit(this.selectedvisit,requestBody);
        this.dashboardServiceservice.cancelVisitSubject.subscribe(
        ( data: any ) => {
          if(data.code =="802ddb379ec8898a9c3fd49cdc5f924c"){
            if (index !== -1) {
              item1.visit_status="Annulée";
              loading.style.display = "none";
              this.cancelVisitForm.reset();
              setTimeout(()=>{
                this.TodayPlanning();
              }, 2000);
            };
            $("#successSave").show();
            $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            setTimeout(()=>{
              $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                // $(this).removeClass();
              });
              $("#successSave").hide();
            }, 5000);
            }else{
            $("#errors").show();
                  $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  setTimeout(()=>{
                    $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                      // $(this).removeClass();
                    });
                    $("#errors").hide();
                  }, 5000);
                  loading.style.display = "none";
          }
        },)
      // }
  }

  showDateInput = false;
  onReportButtonClick() {
    if (!this.showDateInput) {
      this.showDateInput = true;
    }
    if (this.showDateInput && this.cancelVisitForm.valid) {
      this.reportVisit();
      this.showDateInput = false;
    }
  }
  
  reportVisit(){
    if(this.cancelVisitForm.valid){
      (<any>$('#annulerModal')).modal('hide');
      const reportDateValue = this.cancelVisitForm.get('reportDate')?.value;
      const reportDate = reportDateValue ? new Date(reportDateValue) : null;
      const requestBody = {
        cause: this.cancelVisitForm.get('motif')?.value,
        reportDate: reportDate
      };
      let item1 = this.today.find((i:any) => i.visit === this.selectedvisit);
      var index = this.today.indexOf(item1);
      // if(this.exist_incompleted_visit){
        var loading = (document.getElementById("startLoading"+index) as HTMLDivElement);
        loading.style.display = "inline-block";
        this.startLoading = true;
        this.dashboardServiceservice.reportVisit(this.selectedvisit,requestBody);
        this.dashboardServiceservice.reportVisitSubject.subscribe(
        ( data: any ) => {
          if(data.code =="802ddb379ec8898a9c3fd49cdc5f924c"){
            if (index !== -1) {
              item1.visit_status="Reportée";
              loading.style.display = "none";
              this.cancelVisitForm.reset();
              setTimeout(()=>{
                this.TodayPlanning();
              }, 2000);
              
            };
            $("#successSave1").show();
                  $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  setTimeout(()=>{
                    $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                      // $(this).removeClass();
                    });
                    $("#successSave1").hide();
                  }, 5000);
            }else{
            $("#error").show();
                  $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                    // $(this).removeClass();
                  });
                  setTimeout(()=>{
                    $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
                      // $(this).removeClass();
                    });
                    $("#error").hide();
                  }, 5000);
                  loading.style.display = "none";
          }
        },)
      // }
    }
  }
  finishVisit(id:any){
    let item1 = this.today.find(i => i.visit === id);
    var index = this.today.indexOf(item1);
    if (index !== -1) {
      localStorage.removeItem(`startTime_${id}`);
      this.today.splice(index, 1);
      // this.router.navigate(['complete-visit', 'fromComplete', { cr: id }]);
      window.location.href = `/complete-visit/fromComplete;cr=${id}`;

    }
  }
  sells:any[]=[];somme:any=0;
  addDetailToFinish(){
    if(this.terminatedVisitForm.valid){
      var finishVisitFormValues= this.terminatedVisitForm.value;
      this.sells.push(finishVisitFormValues);
    }else {
      this.terminatedVisitForm.markAllAsTouched();
    }
    this.terminatedVisitForm.reset()
  }
  removeDetailToFinish(element:any){
    var item1 = this.sells.find(i => i === element);
    var index = this.sells.indexOf(item1);
    if (index !== -1) {
      this.sells.splice(index, 1);
      this.somme =this.somme - (item1.price*item1.product_unit);
    }
  }
  noSells:boolean=false;rapport:any=null;
  selectTypeFinish(){
    var finishVisitFormValues= this.finishVisitForm.value;
    if(finishVisitFormValues.type_sell=="service"){
      this.finishVisitForm.controls.designation.enable();
      // this.finishVisitForm.controls.price.disable();
      this.finishVisitForm.controls.product_unit.disable();
      this.noSells = false;
    }else if(finishVisitFormValues.type_sell=="product" || finishVisitFormValues.type_sell=="") {
      this.finishVisitForm.controls.designation.enable();
      this.finishVisitForm.controls.price.enable();
      this.finishVisitForm.controls.product_unit.enable();
      this.noSells = false;
    }else {
      this.noSells = true;
      this.finishVisitForm.controls.designation.disable();
      this.finishVisitForm.controls.price.disable();
      this.finishVisitForm.controls.product_unit.disable();
    }
    var type = finishVisitFormValues.type_sell;
    this.finishVisitForm.reset();
    this.finishVisitForm.controls.type_sell.setValue(type);
  }
  selectedVisit:any;
  toSaveVisit(id:any){
    this.selectedVisit = this.programme.find(i => i.uuid === id);
  }
  client:any;
  myFunction() {
    this.finishVisitForm.reset();
    this.sells= [];
    this.rapport="";
    this.somme=0;
    this.client=false;
  }
  ModifyPlaceHolder () {
    var input = document.getElementById ("hEmail") as HTMLInputElement;
    input.placeholder = "Saisir la designation du service";
}
  ModifyPlaceHolder1 () {
    var input = document.getElementById ("hEmail") as HTMLInputElement;
    input.placeholder = "Saisir la designation du produit";
  }
  isToday(date: string): boolean {
    const today = new Date();    
    const plannedAtDate = new Date(date);    
    // Check if the plannedAt date is today
    return plannedAtDate.getDate() === today.getDate() &&
           plannedAtDate.getMonth() === today.getMonth() &&
           plannedAtDate.getFullYear() === today.getFullYear();
}
  today:any[]=[];allVisitsday:any []=[];
  exist_incompleted_visit:boolean=false;
  formatDateToday(apiDate: any): string {    
    return formatInTimeZone(apiDate, 'UTC', 'HH:mm') as any;
  }
  isValidDate(date: any): boolean {
    if (!date) return false;
    const d = new Date(date);
    return !isNaN(d.getTime());
  }
  formatSafeInTimeZone(dateValue: any, timezone: string, format: string): string {
    if (!this.isValidDate(dateValue)) return ''; // ou tout autre valeur par défaut
    return formatInTimeZone(new Date(dateValue), timezone, format);
  }
  TodayPlanning(){
    var globalvar = this;
    this.dashboardServiceservice.getToday();
    this.dashboardServiceservice.todaySubject.subscribe(
      ( data: any ) => {
        if(data.code =="e4b1ffed04086a59b097faa3afbf6197"){
          this.allVisitsday = data.visits;
          this.today = data.visits;
          for(var vis of this.today){
            vis.visit_planned_at_hour = formatInTimeZone(vis.visit_planned_at, 'UTC', 'HH:mm');
            vis.visit_old_planned_at = this.formatSafeInTimeZone(vis.visit_old_planned_at, 'UTC', 'dd/MM/yyyy - HH:mm');
          }
          let index = data.visits.findIndex((iscompleted:any) => !iscompleted.not_completed);  
          let index2 = data.visits.findIndex((visit:any) => visit.visit_status =='En cours');  
          let index3 = data.visits.findIndex((visit :any) => visit.visit_planned_at != null && visit.visit_status== 'En attente de validation');
          if (index2 >= 0) {
            this.exist_incompleted_visit=true;
          }else {
            this.exist_incompleted_visit=false;
          }
          if(data.visits.length==0){
            setTimeout( function() {
              // create the notification
              var notification = new NotificationFx({
                  message : '<img src="assets/img/suivitim_img/calendar_white.gif" style="width: 50px;">'+
                  '<b>RAPPEL</b> : <br><p>Bonjour <b>'+globalvar.connectedCommercial+' </b><br> Aucune visite '+
                  'nˊest planifiée par vous pour aujourdˊhui ! <br>On vous invite à planifier de nouvelles visites <br><br>'+
                  '<img src="assets/img/suivitim_img/toright.gif" style="width: 25px;"><a href="planifier">  Planifier mes visites</a></p>',
                  layout : 'attached',
                  effect : 'bouncyflip',
                  type : 'notice', // notice, warning or error
                  onClose : function() {
                  }
              });
              // show the notification
              notification.show();
            }, 1200 );
          }
        }this.loading_plan = false;
      })
  }
  potential:any;
  GetStats(event: any) {
    this.potential = event.target.checked;
  }
  successTerminatVisit:boolean=true;
  finalactions:any[]=[];
  terminateVisit(mode:any){
    for(var act of this.perso){
      var comment = document.getElementById(act.action) as HTMLTextAreaElement;
      
      var commentedaction = {
        "action": act.action,
        "action_desc": act.action_desc,
        "action_comment":comment.value,
        "action_status":act.status
      } 
      this.finalactions.push(commentedaction);
    }
    // if(this.terminatedVisitForm.valid){
    var body:any ={};
    if(mode=="finish"){
      body = {
        actions : this.finalactions,
        contacts : this.sells,
        pictures : this.picturesVisit
      };
    }else {
      body = {
        actions : this.finalactions,
        contacts : this.sells,
        pictures : this.picturesVisit
      };
    }
    let item1 = this.today.find((i:any) => i.visit === this.selectedvisit);
    var index = this.today.indexOf(item1);
    var loading = (document.getElementById("startLoading"+index) as HTMLDivElement);
    loading.style.display = "inline-block";
    var successTerminatVisit = (document.getElementById("successTerminatVisit-"+index) as HTMLDivElement);
    var encoursStatus = (document.getElementById("encours-status-"+index) as HTMLDivElement);
    var terminateAction = (document.getElementById("terminate-action-"+index) as HTMLDivElement);
    this.startLoading = true;
    this.dashboardServiceservice.bodyFinish = body;
    this.dashboardServiceservice.terminateVisit(this.selectedvisit,mode);
    this.dashboardServiceservice.startVisitSubject.subscribe(
    ( data: any ) => {
      if(data.code =="fe01fa6623c3648dcd4e15c482a2d602"){
        this.exist_incompleted_visit=false;
        if (index !== -1) {
          loading.style.display = "none";
          this.successTerminatVisit = false;
          if(encoursStatus != null){
            encoursStatus.style.display = "none";//hide block En cours
          }
          if(terminateAction != null){
            terminateAction.style.display = "none";//hide block btn terminate
          }
          if(successTerminatVisit != null){
            successTerminatVisit.style.display = "inline-block"; 
          }
          setTimeout(()=>{
            this.TodayPlanning();
          }, 2000);
          setTimeout(()=>{
            this.finishVisitForm.reset();
            this.sells = [];
            this.picturesVisit = [];
            this.perso = [];
            this.finalactions = [];
            this.adaptedActions = [];
            successTerminatVisit.style.display = "none";
          },2000);
          setTimeout(()=>{
            item1.visit_status="Terminée";
            this.Terminated();
            this.getCalendarVisits()
          },2000);  
        }
      }
    })
  // }
  }

  terminatedvisits:any[]=[];
  loading_old_visits:boolean=false;
  Terminated(){
    this.loading_old_visits = true;
    this.dashboardServiceservice.getTerminated();
    this.dashboardServiceservice.terminatedSubject.subscribe(
      ( data: any ) => {        
        if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
          this.terminatedvisits = data.visits.sort((a:any, b:any) => (a.date_publication > b.date_publication ? -1 : 1));
        }
        this.loading_old_visits = false;
      })
  }
  terminatedlistvisits:any[]=[];
  loading_list:boolean=false;
  Terminatedlist(){
    this.loading_list = true;
    this.dashboardServiceservice.getTerminatedlist();
    this.dashboardServiceservice.terminatedlistSubject.subscribe(
      ( data: any ) => {
        if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
          this.terminatedlistvisits = data.visits.sort((a:any, b:any) => (a.date_publication > b.date_publication ? -1 : 1));
      }this.loading_list = false;
    })
  }
  existImportantComment:boolean=false;
  getVisitsToReplyNotif(){
    this.loading_list = true;
    this.dashboardServiceservice.getTerminatedlist();
    var toReply = false;
    var visitsCustomers:any[] = [];
    this.dashboardServiceservice.terminatedlistSubject.subscribe(
      ( data: any ) => {
        if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
          this.terminatedlistvisits = data.visits.sort((a:any, b:any) => (a.date_publication > b.date_publication ? -1 : 1));
          for(let visit of this.terminatedlistvisits){
            if(visit.hasComments && visit.commentsToReply){
              this.existImportantComment = true;
              toReply=true;
              visitsCustomers.push(visit);
            }else if(visit.hasComments && !visit.commentsToReply){
              // toReply=true;
              // visitsCustomers.push(visit);
            }else {
              this.existImportantComment = false;
            }
          }
          if(toReply){
            //SHOW NOTIFICATION TO COMMERCIAL TO CREATE NEW VISITS
            var messageNotifToReply = '<img src="assets/img/suivitim_img/notif_comment_reply.gif" style="width: 50px;">'+
            '<b>NOUVEAUX COMMENTAIRES</b> <br><p class="text-justify" >Bonjour <b> </b><br> Vous avez '+
            'de nouveaux commentaires ajoutés par le directeur au sujet ';
            if(visitsCustomers.length>0 && visitsCustomers.length==1){
              messageNotifToReply = messageNotifToReply +'de la visite terminée du client : <b><a style="color:black !important;" href="/visite/detail/fromcomments;cr='+visitsCustomers[0].report_visit+'">'+
                visitsCustomers[0].report_customer+'</a></b><br><br>'+
              '</p>';
            }else if(visitsCustomers.length>0 && visitsCustomers.length>1){
              messageNotifToReply = messageNotifToReply +'des visites terminées des clients :<br><ul>'
              for(let vis of visitsCustomers){
                messageNotifToReply = messageNotifToReply +'<li><b><a style="color:black !important; text-decoration:underline" href="/visite/detail/fromcomments;cr='+vis.report_visit+'">'+vis.report_customer+'</a></b>';
                if(vis.has_important_comment){
                  messageNotifToReply = messageNotifToReply +' (Important)';
                }
                messageNotifToReply = messageNotifToReply +'</li>';
              }
              messageNotifToReply = messageNotifToReply +'</ul><br>'+
              '</p>';
            }
            setTimeout( function() {
              // create the notification
              var notification = new NotificationFx({
                  message : messageNotifToReply,
                  layout : 'growl',
                  effect : 'slide',
                  type : 'warning', // notice, warning or error
                  onClose : function() {
                  }
              });
              // show the notification
              notification.show();
            }, 1200 );
          }
      }this.loading_list = false;
    })
  }
  detail:any;
  perso:any;
  actions:any;
  terminer_plan:boolean=true;
  adaptedActions:any[]=[];
  Detail(id:any){
    this.perso =[];
    this.terminer_plan=true;
    this.visitService.getDetail(id);
    this.visitService.detailSubject.subscribe(
      ( data: any ) => {
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.detail= data.visit;
          this.msSector.getSector(this.msToken,this.detail?.visit_customer_sector).subscribe(
            (sectorLabel: any) => {
              this.detail.customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          this.perso= data.visit.actions;
          
          for(var ac of this.perso){
            var adaptedAction = {
              action: ac.action,
              action_comment: ac.action_comment,
              action_desc: ac.action_desc,
              status:"En cours",
              new:false
            }
            
            if(ac.action_status!=null){
              adaptedAction.status=ac.action_status;
            }
            this.adaptedActions.push(adaptedAction);
          }
          
          this.perso = this.adaptedActions;
          // this.CustumizedListactions(this.visit.visit_customer_uuid)
          // if(data.visit.actions != null && data.visit.actions != undefined)
          // this.actions= data.visit.actions.sort((a:any, b:any) => a.action_date - b.action_date);
          // this.actions= data.actions;
        }this.terminer_plan=false;
      },
    )  
  }
  togenerateUuid:any=13;
  addNewAction(){
    // var checked = document.querySelector('input[name="statusAction"]:checked')as ;
    if($("#new_action").val()!=null && $("#new_action").val()!=" " 
      && $("#new_action").val()!=undefined && $("#new_action").val()!=""){
      var newAction:any={
        action: getUniqueId(this.togenerateUuid),
        action_comment: $("#new_comment").val(),
        action_desc: $("#new_action").val(),
        status:$("input[type='radio'][name='statusAction']:checked").val(),
        new:true
      };
      this.perso.push(newAction);
      this.togenerateUuid = this.togenerateUuid + 11;
      $("#new_comment").val(null);
      $("#new_action").val(null);
    }
  }
  addNewActionInUpdate(){
    // var checked = document.querySelector('input[name="statusAction"]:checked')as ;
    
    if($("#new_action_update").val()!=null && $("#new_action_update").val()!=" " 
      && $("#new_action_update").val()!=undefined && $("#new_action_update").val()!=""){
      var newAction:any={
        action: getUniqueId(this.togenerateUuid),
        action_comment: $("#new_comment_update").val(),
        action_desc: $("#new_action_update").val(),
        status:$("input[type='radio'][name='statusAction']:checked").val(),
        new:true
      };
      this.person.push(newAction);
      this.togenerateUuid = this.togenerateUuid + 11;
      $("#new_comment_update").val(null);
      $("#new_action_update").val(null);
    }
  }
  verifylenght(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/5000</span>";
      if(len<=5000){
        $("#lenght-"+event.target.id).html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#lenght-"+event.target.id).html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#lenght-"+event.target.id).html("<span style='color:green'><span>0/5000</span></span>");
    }
  }
  verifylenghtNewComment(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/5000</span>";
      if(len<=5000){
        $("#lenght-newComment").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#lenght-newComment").html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#lenght-newComment").html("<span style='color:green'><span>0/5000</span></span>");
    }
  }
  verifylenghtCommentVisit(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/5000</span>";
      
      if(len<=5000){
        $("#count-comment-visit").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#count-comment-visit").html("<span style='color:red'"+toshowNumber+"</span>");
      }
      if(len<=5000){
        $("#count-comment-visit-upd").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#count-comment-visit-upd").html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#count-comment-visit").html("<span style='color:green'><span>0/5000</span></span>");
      $("#count-comment-visit-upd").html("<span style='color:green'><span>0/5000</span></span>");
    }
  }
  retrieved:any;person:any;contact:any;
  adaptedUpdateActions:any[]=[];
  Retrieve(id:any){
    var newArray:any[] = [];
    this.imgArray = newArray;
    this.person=[];
    var glob = this;
    this.adaptedUpdateActions=[];
    this.terminer_plan=true;
    this.visitService.getRetrieve(id);
    this.visitService.retrieveSubject.subscribe(
      ( data: any ) => {
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.terminer_plan=false;
          this.retrieved = data.visit;
          this.msSector.getSector(this.msToken,this.retrieved?.visit_customer_sector).subscribe(
            (sectorLabel: any) => {
              this.retrieved.customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          // this.person= data.visit.actions;
          for(var ac of data.visit.actions){
            var adaptedAction = {
              action: ac.action,
              action_comment: ac.action_comment,
              action_desc: ac.action_desc,
              status:"En cours",
              new:false
            }
            
            if(ac.action_status!=null){
              adaptedAction.status=ac.action_status;
            }
            this.adaptedUpdateActions.push(adaptedAction);
          }
          var len = 0;
          var iterator:any = 0;
          this.imgArray=[];
          // $('#upload__img-wrap') 
          setTimeout(() => {
            this.imgWrap = document.getElementById('upload__img-wrap');
            if (data.visit.picturesVisit != null) {
                for (let pic of data.visit.picturesVisit) {
                    newArray.push(pic);
                    var html = "<div class='upload__img-box col-lg-3'><div style='background-image: url(data:image/jpeg;base64," + pic + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + pic.name + "' class='img-bg'></div></div>";
                    this.imgWrap.innerHTML += html;
                }
                this.imgArray = newArray;
                
                this.picturesVisitUpdate = data.visit.picturesVisit;
                this.picturesVisit = data.visit.picturesVisit
            }
          }, 1000);
          
          this.person = this.adaptedUpdateActions;
          
          this.sells= data.visit.contacted_persons;
        }
        this.adaptedUpdateActions=[];
      },
    )  
  }
  
  removeAddedAction(uuid:any,list:any[]){
    let index = list.findIndex((d:any) => d.action === uuid);
    list.splice(index, 1);
  }
  modifyloading:boolean=false;
  modifyrepport(mode:any){
    this.modifyloading=true;
    for(var act of this.person){
      var comment = document.getElementById(act.action) as HTMLTextAreaElement;
      
      var commentedaction = {
        "action": act.action,
        "action_desc": act.action_desc,
        "action_comment":comment.value,
        "action_status":act.status
      } 
      this.finalactions.push(commentedaction);
    }
    // if(this.terminatedVisitForm.valid){
    var terminateBody = {
      actions : this.finalactions,
      contacts : this.sells,
      pictures : this.picturesVisit
    };
    this.dashboardServiceservice.bodyFinish = terminateBody;
    
    this.dashboardServiceservice.terminateVisit(this.cause,mode);
    this.dashboardServiceservice.startVisitSubject.subscribe(
    ( data: any ) => {
      
        if(data.code =="fe01fa6623c3648dcd4e15c482a2d602"){
          this.Terminatedlist();
          this.Terminated();
          this.picturesVisitUpdate = [];
          this.imgArray =[];
          this.imgWrap = $('.upload__img-wrap');
          this.imgWrap.append("");
          this.person=[];
          $("#successSave2").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-gradient').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#successSave").hide();
          }, 5000);
          this.modifyloading=false;
          
        }else{
          $("#errors").show();
          $('.alert-danger').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
            // $(this).removeClass();
          });
          setTimeout(()=>{
            $('.alert-danger').removeClass().addClass('fadeOut animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
              // $(this).removeClass();
            });
            $("#errors").hide();
          }, 5000);
          this.modifyloading=false;
        }
        this.finalactions = [];
      }
    ,)
  // }
}

// action plan
currentBlocIndicator(event:any) {
  event.currentTarget.classList.add("action_plan_active");
  // Get all buttons with class="btn" inside the container
  var btns = document.getElementsByClassName("action_plan_indicator");
  for (var i = 0; i < btns.length; i++) {      
    if(btns[i]!=event.currentTarget){
      btns[i].classList.remove("action_plan_active")
    }
  }
  this.actionsPlanRetrieved=false;
}
indicators:any;
loadingIndicatorsPlan:boolean=false;
indicatorsActionsPlan(uuid:any){
  this.actionsPlanRetrieved = false;
  this.actionsPlan=[];
  $('.icon_click_here').delay(300).fadeIn(2000);  
  this.loadingIndicatorsPlan = true;  
  this.dashboardServiceservice.getActionsPlanIndicators(uuid).subscribe(
    ( data: any ) => {
      this.indicators = data.indicators;        
      this.actionsPlanRetrieved=false;
      setTimeout(()=>{
        this.loadingIndicatorsPlan = false; 
      }, 1000);
      // Get all buttons with class="btn" inside the container
    setTimeout(()=>{
      $('.icon_click_here').delay(300).fadeOut(2000);
    }, 2000);
  },
    error => {
      console.error('There was an error!', error);
      this.loadingIndicatorsPlan = false; 
    });
} 
actionsPlan:any;
loadingPlanActions:boolean=false;
actionsPlanRetrieved:boolean=false;
selected_type_plan_action:any;
// no_actions_plan_to_show:boolean=false;
status!:string;
modal!:string;
memberOrAllUuid!:string;
retrieveActionsPlan(status:any,modal:any,memberOrAllUuid:any){
  this.status = status;
  this.modal = modal;
  this.memberOrAllUuid= memberOrAllUuid;
  this.actionsPlanRetrieved = false;
  this.actionsPlan=[];
  var id = memberOrAllUuid;    
  this.selected_type_plan_action = memberOrAllUuid;
  this.loadingPlanActions = true;  
  this.dashboardServiceservice.getActionsPlan(id,status);
  this.dashboardServiceservice.actionsPlanSubject.subscribe(
    ( data: any ) => {
      if(data.code=="b8f8289ade38c75780d8156c9d8fd624" && data.actions != null){
        this.actionsPlan = data.actions.sort((a:any, b:any) => new Date(a.action_added_at).getTime() - new Date(b.action_added_at).getTime());                  
        setTimeout(()=>{
          this.loadingPlanActions = false; 
          this.actionsPlanRetrieved = true;
        }, 200);
        // this.no_actions_plan_to_show=false;
        if(modal=="customer"){
          setTimeout(()=>{
            // this.loadingPlanActions = false; 
            (<any>$('#actions_plan_table_customer')).DataTable().destroy();
            (<any>$("#actions_plan_table_customer")).DataTable( {
              "pagingType": "full_numbers",
              "scrollY": '400px',
              "scrollX": '400px',
              order: [[4, 'desc']],
              "scrollCollapse": false,
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                    type: 'line',
                    width: '60',
                    height: '20',
                    lineColor: '#1a73e9',
                    fillColor: '#c2d5ff',
                    spotColor: 'transparent',
                    minSpotColor: 'transparent',
                    maxSpotColor: 'transparent',
                    highlightSpotColor: 'transparent',
                    highlightLineColor: 'transparent',
                });
              }
            });
          }, 800);
        }else {
          setTimeout(()=>{
            (<any>$('#actions_plan_table')).DataTable().destroy();
            
            (<any>$("#actions_plan_table")).DataTable( {
              "pagingType": "full_numbers",
              "scrollY": '400px',
              "scrollX": '400px',
              order: [[4, 'asc']],
              "scrollCollapse": false,
              "language": {
                "sProcessing": "Traitement en cours ...",
                "sLengthMenu": "Afficher _MENU_ lignes",
                "sZeroRecords": "Aucun résultat trouvé",
                "sEmptyTable": "Aucune donnée disponible",
                "sInfo": "",
                "sInfoEmpty": "",
                searchPlaceholder: "Saisir un mot clé",
                "sInfoFiltered": "",
                "sInfoPostFix": "",
                "sSearch": "Rechercher:",
                "sUrl": "",
                "sInfoThousands": ",",
                "sLoadingRecords": "Chargement...",
                "oPaginate": {
                  "sFirst": "<i class='flaticon-left-arrow'></i>", "sLast": "<i class='flaticon-right-arrow'></i>", "sNext": "<i class='flaticon-arrow-right'></i>", "sPrevious": "<i class='flaticon-arrow-left-1'></i>"
                },
                "oAria": {
                  "sSortAscending": ": Trier par ordre croissant", "sSortDescending": ": Trier par ordre décroissant"
                }
              },
              drawCallback: function () {
                (<any>$('.sparkline')).sparkline([5,6,7,9,9,5,3,2,2,4,6,7], {
                    type: 'line',
                    width: '60',
                    height: '20',
                    lineColor: '#1a73e9',
                    fillColor: '#c2d5ff',
                    spotColor: 'transparent',
                    minSpotColor: 'transparent',
                    maxSpotColor: 'transparent',
                    highlightSpotColor: 'transparent',
                    highlightLineColor: 'transparent',
                });
              }
            });
          }, 800);
        }
      }else {
        this.loadingPlanActions = false; 
      }
  })
} 

generateCsvCommercialLoading:boolean = false;
generateCsvCustomersLoading:boolean = false;
generateCsv(status:string,modal:string,memberOrAllUuid:string){
  this.generateCsvCommercialLoading = true;
  this.dashboardServiceservice.generateCsv(memberOrAllUuid,status).subscribe(
    ( data: any ) => {
      if(data.code =="b8f8289ade38c75780d8156c9d8fd624"){
        const source = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,` + data.fileEnv.file;
        const link = document.createElement("a");
        link.href = source;
        link.download = data.fileEnv.fileName;
        link.click();
      }
      this.generateCsvCommercialLoading = false;
    },
    (err: any) => {
      console.log(err);
      this.generateCsvCommercialLoading = false;
    }
    )
}

  //CALENDAR CALL DATA
  addeventtocalendar(){
    for(var event of this.list){
      var daycase = document.querySelector("tr td.fc-day-top[data-date='"+event.start+"']")as any;
      if(daycase != null){
        daycase.innerHTML='<a class="fc-day-grid-event fc-h-event fc-event fc-start fc-end fc-event--blue this-date" this-data="'+event.title+'">'+
        "<div class='fc-content' data-container='body' data-html='true' data-placement='top'>"+"<span class='fc-title'>"+event.title+"</span>"
      }
      
    }
  }
  calendarLoading:boolean=true;
  getCalendarVisits(){
    var glob = this;
    this.calendarLoading=true;
    var startDate = document.getElementById('startDate') as HTMLInputElement;
    var endDate = document.getElementById('endDate') as HTMLInputElement;
    
    this.dashboardServiceservice.getVisitsCalendar(startDate.value,endDate.value);
    this.dashboardServiceservice.calendarSubject.subscribe(
      ( data: any ) => {
        if(data.code =="0d7cf8bfb6a3d0d3c57e26777021b1e6"){
          this.list = data.visits;
          var today = new Date();
          var y = today.getFullYear();
          var m = today.getMonth();
          var d = today.getDate();
          setTimeout(()=>{
            $('#c').fullCalendar({
                header: {
                    left: "prev,next",
                    center: "title",
                    right: "month,agendaWeek,agendaDay"
                },
                editable: true,
                responsive:true,
                droppable: false, // this allows things to be dropped onto the calendar
                eventLimit: true,
                dayMaxEvents: 30,
                buttonText: {
                    today:    "Aujourd'hui",
                    month:    'mois',
                    week:     'semaine',
                    day:      'jour',
                    allDay: 'jours'
                },
                dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                dayNames: ["Dimanche", "Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi"],
                monthNamesShort:['Jan', 'Fev', 'Mar', 'Avr', 'Mai', 'Jui',
                    'Juil', 'Aout', 'Sep', 'Oct', 'Nov', 'Déc'],
                monthNames:['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
                    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
                timeFormat: "",
                events: glob.list
            });
            setTimeout(()=>{
              for(let event of glob.list){
                var ev = (document.querySelector("[this-date-uuid='"+event.uuid+"']")) as any;
                if(event.inProgress){
                  if(ev!=undefined && ev!=null){
                    var parenthyper = ev.parentElement;
                    parenthyper.parentElement.classList.add("encours");
                  }
                }
              }
            }, 1000);
            startDate = document.getElementById('startDate') as HTMLInputElement;
              endDate= document.getElementById('endDate') as HTMLInputElement;
              var columnCalendar = document.querySelector('[data-date="'+startDate.value+'"]') as HTMLElement;
              if(columnCalendar != null){
                columnCalendar.style.backgroundColor="#d7fff2";
              }
              var columnCalendar = document.querySelector('[data-date="'+endDate.value+'"]') as HTMLElement;
              if(columnCalendar != null){
                columnCalendar.style.backgroundColor="#d7fff2";
              }
              for (var d:any = new Date(startDate.value); d <= new Date(endDate.value); d.setDate(d.getDate() + 1)) {
                var stringDate = this.formatDate(d);
                var columnCalendar = document.querySelector('[data-date="'+stringDate+'"]') as HTMLElement;
                if(columnCalendar != null){
                  columnCalendar.style.backgroundColor="#d7fff2";
                }
              }
          }, 800);
          setTimeout(()=>{
            this.addeventtocalendar();
          }, 2000);
          this.calendarLoading=false;
        }
      },
    ) 
  }
  formatDate(date:Date) { 
    date = new Date(date);
    var stDate = date.getFullYear()+"-"
    if(date.getMonth()<10){
      stDate = stDate+"0"+(date.getMonth()+1);
      
    }else {
      stDate = stDate +(date.getMonth()+1);
    }
    if(date.getDate()<10){
      stDate = stDate+"-0"+date.getDate()
    }else {
      stDate = stDate+"-"+date.getDate();
    }    
    return stDate;
   }
  closeNewsModal() {
    (<any>$('#newsModal')).modal('hide');
  }
  Pdf(id_visit:any){
    this.dashboardServiceservice.getPdf(id_visit);
    this.dashboardServiceservice.pdfSubject.subscribe(
    ( data: any ) => {
      if(data.code =="f3030809fbd166bcc94653d58a6e6a47"){
      const source = `data:application/pdf;base64,`+data.report;
      const link = document.createElement("a");
      link.href = source;
      link.download = data.report_filename;
      link.click();
      }
    })
  }
  messagesvisit:any[]=[];
  loading_messages_visit:boolean=false;
  // messagesVisit(visit:any){
  //   this.loading_messages_visit = true;
  //   this.visitService.getMessagesVisit(visit);
  //   this.visitService.messagesVisitSubject.subscribe(
  //     ( data: any ) => {
  //       if(data.code =="7f970252917c98638f9235a0f80b2bcd"){
  //         this.terminatedlistvisits = data.visits.sort((a:any, b:any) => (a.date_publication > b.date_publication ? -1 : 1));
  //     }this.loading_messages_visit = false;
  //   })
  // }

  MarkAsRead(visit:any){
    this.dashboardServiceservice.markAsRead(visit, null);
    this.dashboardServiceservice.markAsReadSubject.subscribe(
      ( data: any ) => {
    })
  } 
}
